import { matchingTypes } from '@@/advertisement/common/constants';
import translateMatchTypes from './translateMatchTypes';

export default translateMatchTypes(matchingTypes);
